import { CalendarPlus, ExternalLink, Download } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { googleUrl, icsUrl } from "../../lib/calendarLinks";

const link = "inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-[color:var(--border)] hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] text-[10px] uppercase tracking-widest transition-colors";

const Row = ({ label, session, date, mode, season }) => (
  <div className="flex items-center justify-between gap-3" data-testid={`cal-row-${mode}`}>
    <span className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">{label}</span>
    <div className="flex gap-1.5">
      <a href={googleUrl(session, date, mode, season)} target="_blank" rel="noopener noreferrer" data-testid={`cal-${mode}-google`} className={link}>Google <ExternalLink className="w-3 h-3" /></a>
      <a href={icsUrl(session, date, mode)} data-testid={`cal-${mode}-ics`} className={link}>iCal <Download className="w-3 h-3" /></a>
    </div>
  </div>
);

export const AddToCalendar = ({ session, date, season, label }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={`add-to-calendar-${session.course_id}-${session.start}`}
        aria-label="Ajouter à mon agenda"
        title="Ajouter à mon agenda"
        className={label
          ? "inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[color:var(--border)] hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] text-[10px] uppercase tracking-widest transition-colors"
          : "w-6 h-6 grid place-items-center rounded-full text-[color:var(--text-muted)] hover:text-[color:var(--accent)] hover:bg-white/5 transition-colors"}
      >
        <CalendarPlus className="w-3.5 h-3.5" />{label}
      </button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-72 p-4 space-y-3 bg-[color:var(--bg-elev)] border-[color:var(--border)] text-[color:var(--text)]" data-testid="add-to-calendar-menu">
      <div>
        <div className="font-display text-xl leading-none">Ajouter à mon agenda</div>
        <div className="text-[10px] text-[color:var(--text-muted)] mt-1">{session.course_name} · {session.start}–{session.end}</div>
      </div>
      <Row label="Cette séance" mode="single" session={session} date={date} season={season} />
      <Row label="Toute la saison" mode="season" session={session} date={date} season={season} />
      <p className="text-[9px] text-[color:var(--text-muted)]">iCal : Apple Calendar, Outlook, Thunderbird… Les jours fériés définis par la régie sont exclus.</p>
    </PopoverContent>
  </Popover>
);
